import { useEffect, useRef, useState } from 'react';
import './mapEmbed.scss';

const YMAP_CONSTRUCTOR_ID = '1a75a177016a445706600eecc06cc61be4bb14ef076e8d768e2397298e8610df';

const MapEmbed: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isInteractive, setIsInteractive] = useState(false);
    const holderRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const el = holderRef.current;
        if (!el) return;
        if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
                (entries) => {
                    if (entries.some((e) => e.isIntersecting)) {
                        setIsVisible(true);
                        io.disconnect();
                    }
                },
                { rootMargin: '200px 0px' },
            );
            io.observe(el);
            return () => io.disconnect();
        } else {
            setIsVisible(true);
        }
    }, []);

    const iframeSrc = `https://yandex.ru/map-widget/v1/?um=constructor%3A${encodeURIComponent(YMAP_CONSTRUCTOR_ID)}&source=constructor&scroll=true&lang=ru_RU`;

    const activate = () => setIsInteractive(true);
    const deactivate = () => setIsInteractive(false);

    const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
        if (!isInteractive && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            activate();
        }
    };

    return (
        <div ref={holderRef} className="mapEmbed__holder">
            {isVisible ? (
                <div className={`mapEmbed ${isInteractive ? 'mapEmbed--interactive' : ''}`}>
                    <button type="button" onClick={deactivate} className="mapEmbed__deactivateBtn" aria-label="Отключить взаимодействие с картой">
                        Отключить карту
                    </button>

                    <iframe
                        title="Карта S-Gabai на Яндекс.Картах"
                        src={iframeSrc}
                        className="mapEmbed__iframe"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />

                    {/* Оверлей: в неактивном режиме принимает клик, но НЕ блокирует скролл страницы */}
                    <div
                        ref={overlayRef}
                        role="button"
                        aria-label="Включить взаимодействие с картой"
                        tabIndex={0}
                        onClick={activate}
                        onKeyDown={handleKeyDown}
                        className="mapEmbed__overlay"
                    >
                        {!isInteractive && <span className="mapEmbed__hint">Нажмите, чтобы активировать карту</span>}
                    </div>
                </div>
            ) : (
                <div aria-hidden="true" className="mapEmbed__skeleton" />
            )}

            <noscript>
                <p>
                    Карта недоступна без JavaScript.{' '}
                    <a href="https://yandex.ru/maps/-/CHdaa8Ms" target="_blank" rel="noopener noreferrer">
                        Открыть в Яндекс.Картах
                    </a>
                </p>
            </noscript>
        </div>
    );
};

export default MapEmbed;
